import { KPTYPE } from "../components/KPTComponents/KPTextform/KPTextform";

export const WORKING_PROCESS_MODEL = {
    startTime: { key: 'startTime', label: 'Thời gian công tác (Từ)', type: KPTYPE.date, required: true },
    endTime: { key: 'endTime', label: 'Thời gian công tác (Đến)', type: KPTYPE.date, required: true },
    unit: { key: 'unit', label: 'Tên cơ quan công tác', required: true },
    unitAddress: { key: 'unitAddress', label: 'Địa chỉ cơ quan', required: true },
    position: { key: 'position', label: 'Chức vụ', required: true },
};
